const testResizeWindow = function (x, y) {
  window.innerWidth = x;
  window.innerHeight = y;
  window.dispatchEvent(new Event('resize'));
};

export default testResizeWindow;
